import { Component, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

export interface RejectCompanyDialogData {
  companyId: string;
  companyName: string;
}

@Component({
  selector: 'app-reject-company-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './reject-company-dialog.html',
  styleUrl: './reject-company-dialog.scss',
})
export class RejectCompanyDialog {
  reason = '';
  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(
    private dialogRef: MatDialogRef<RejectCompanyDialog>,
    private admin: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: RejectCompanyDialogData
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.reason.trim()) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin.reject(this.data.companyId, this.reason).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to reject company.'));
      },
    });
  }
}
